import i18n from '@/lang'

import { Message } from 'element-ui'

export const success = () => {
    Message.success(i18n.tc('form.success'))
}
export const fail = () => {
    Message.error(i18n.tc('form.fail'))
}

export const failMsg = (msg = '') => {
    if (typeof msg !== 'string') {
        let msgL = ''
        switch (i18n.locale) {
            case 'chinese':
                msgL = '未知的错误'
                break
            case 'english':
                msgL = 'An unknown error'
                break
            default:
                msgL = 'An unknown error'
                break
        }
        Message.error(msgL)
    } else {
        let msgList = msg.split('\n')
        let msgL = ''
        switch (i18n.locale) {
            case 'chinese':
                msgL = msgList[0]
                break
            case 'english':
                msgL = msgList[1]
                break
            default:
                msgL = msgList[1]
                break
        }
        Message.error(msgL)
    }
}

export const getAllParams = geturl => {
    const url = geturl //获取url中"?"符后的字串
    let theRequest = new Object()
    if (url.indexOf('?') != -1) {
        let str = url.substr(1)
        strs = str.split('&')
        for (let i = 0; i < strs.length; i++) {
            theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
        }
    }
    return theRequest
}
export const isMobile = () => {
    if (
        window.navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
        )
    ) {
        return true // 移动端
    } else {
        return false // PC端
    }
}

export const inserSeoElement = (titleText, key, dec) => {
    const head = document.head || document.getElementsByTagName('head')[0]
    const meta = document.getElementById('tkdKey') || document.createElement('meta')
    const meta2 = document.getElementById('tkdDec') || document.createElement('meta')
    const title = document.getElementById('tdkTitle') || document.createElement('title')
    title.innerText = titleText

    title.setAttribute('id', 'tdkTitle')

    meta.setAttribute('name', 'keywords')
    meta.setAttribute('content', key)
    meta.setAttribute('id', 'tkdKey')

    meta2.setAttribute('name', 'description')
    meta2.setAttribute('id', 'tkdDec')
    meta2.setAttribute('content', dec)

    if (!document.getElementById('tkdDec')) {
        head.insertBefore(meta2, head.children[0])
    }

    if (!document.getElementById('tkdKey')) {
        head.insertBefore(meta, head.children[0])
    }
    if (!document.getElementById('tdkTitle')) {
        head.insertBefore(title, head.children[0])
    }
}
